import React, { ReactNode } from 'react';
import cn from 'classnames';
import { THEME } from '@mos-cat/tooltip';

import './Tooltip.pcss';

interface TooltipProps {
  className?: string;
  position?: string;
  theme: THEME;
  content: any;
  children?: ReactNode;
  isOpen: boolean;
}

function Tooltip({
  className,
  position = 'top',
  theme,
  content,
  children,
  isOpen,
}: TooltipProps): JSX.Element {
  const contentClassNames = cn(
    'Tooltip',
    { [`Tooltip_${position}`]: true },
    `Block_${theme}`,
    `Block_${theme}_bordered`
  );

  const childWrapperClassNames = cn('Tooltip__wrapper', className);

  const wrapperClassNames = cn(
    'TooltipWrapper',
    `TooltipWrapper_${theme}`,
    `TooltipWrapper_${theme}_bordered`
  );
  const child = React.Children.only(children);

  return (
    <div className={childWrapperClassNames}>
      {isOpen && (
        <div className={wrapperClassNames}>
          <div className={contentClassNames}>{content}</div>
        </div>
      )}
      {child}
    </div>
  );
}

export default Tooltip;
